//taken from https://github.com/LucianoGanga/country-codes-list/blob/master/countriesData.js

//Determine for each country the price region and the applicable VAT. Leave vatRate when no applicable
const countriesRegions = [
    {
        countryCode: 'AD',
        region: 'Europe'
    },
    {
        countryCode: 'AF',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'AG',
        region: 'South/Latin America'
    },
    {
        countryCode: 'AI',
        region: 'South/Latin America'
    },
    {
        countryCode: 'AL',
        region: 'Europe'
    },
    {
        countryCode: 'AM',
        region: 'Europe'
    },
    {
        countryCode: 'AO',
        region: 'Africa'
    },
    {
        countryCode: 'AQ',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'AR',
        region: 'South/Latin America'
    },
    {
        countryCode: 'AS',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'AT',
        region: 'Europe1',
        vatRate: 0.2
    },
    {
        countryCode: 'AU',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'AW',
        region: 'South/Latin America'
    },
    {
        countryCode: 'AX',
        region: 'Europe'
    },
    {
        countryCode: 'AZ',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'BA',
        region: 'Europe'
    },
    {
        countryCode: 'BB',
        region: 'South/Latin America'
    },
    {
        countryCode: 'BD',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'BE',
        region: 'Europe1',
        vatRate: 0.21
    },
    {
        countryCode: 'BF',
        region: 'Africa'
    },
    {
        countryCode: 'BG',
        region: 'Europe1',
        vatRate: 0.2
    },
    {
        countryCode: 'BH',
        region: 'Arab States'
    },
    {
        countryCode: 'BI',
        region: 'Africa'
    },
    {
        countryCode: 'BJ',
        region: 'Africa'
    },
    {
        countryCode: 'BL',
        region: 'South/Latin America'
    },
    {
        countryCode: 'BM',
        region: 'North America'
    },
    {
        countryCode: 'BN',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'BO',
        region: 'South/Latin America'
    },
    {
        countryCode: 'BQ',
        region: 'Unknown'
    },
    {
        countryCode: 'BR',
        region: 'South/Latin America'
    },
    {
        countryCode: 'BT',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'BV',
        region: 'South/Latin America'
    },
    {
        countryCode: 'BW',
        region: 'Africa2'
    },
    {
        countryCode: 'BY',
        region: 'Europe'
    },
    {
        countryCode: 'BZ',
        region: 'South/Latin America'
    },
    {
        countryCode: 'CA',
        region: 'North America'
    },
    {
        countryCode: 'CH',
        region: 'Europe1',
        vatRate: 0.77
    },
    {
        countryCode: 'CI',
        region: 'Africa'
    },
    {
        countryCode: 'CL',
        region: 'South/Latin America'
    },
    {
        countryCode: 'CM',
        region: 'Africa'
    },
    {
        countryCode: 'CN',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'CO',
        region: 'South/Latin America'
    },
    {
        countryCode: 'CR',
        region: 'South/Latin America'
    },
    {
        countryCode: 'CU',
        region: 'South/Latin America'
    },
    {
        countryCode: 'CV',
        region: 'Africa'
    },
    {
        countryCode: 'CW',
        region: 'Unknown'
    },
    {
        countryCode: 'CX',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'CY',
        region: 'Europe1'
    },
    {
        countryCode: 'DE',
        region: 'Europe1',
        vatRate: 0.19
    },
    {
        countryCode: 'DJ',
        region: 'Africa'
    },
    {
        countryCode: 'DK',
        region: 'Europe1',
        vatRate: 0.21
    },
    {
        countryCode: 'DM',
        region: 'South/Latin America'
    },
    {
        countryCode: 'DZ',
        region: 'Africa2'
    },
    {
        countryCode: 'EC',
        region: 'South/Latin America'
    },
    {
        countryCode: 'EE',
        region: 'Europe1'
    },
    {
        countryCode: 'EG',
        region: 'Africa2'
    },
    {
        countryCode: 'EH',
        region: 'Africa'
    },
    {
        countryCode: 'ER',
        region: 'Africa'
    },
    {
        countryCode: 'ES',
        region: 'Europe1',
        vatRate: 0.21
    },
    {
        countryCode: 'ET',
        region: 'Africa'
    },
    {
        countryCode: 'FI',
        region: 'Europe1'
    },
    {
        countryCode: 'FJ',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'FM',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'FR',
        region: 'Europe1',
        vatRate: 0.2
    },
    {
        countryCode: 'GA',
        region: 'Africa'
    },
    {
        countryCode: 'GD',
        region: 'South/Latin America'
    },
    {
        countryCode: 'GE',
        region: 'Europe'
    },
    {
        countryCode: 'GF',
        region: 'South/Latin America'
    },
    {
        countryCode: 'GG',
        region: 'Europe'
    },
    {
        countryCode: 'GH',
        region: 'Africa'
    },
    {
        countryCode: 'GI',
        region: 'Europe'
    },
    {
        countryCode: 'GL',
        region: 'Europe'
    },
    {
        countryCode: 'GN',
        region: 'Africa'
    },
    {
        countryCode: 'GP',
        region: 'South/Latin America'
    },
    {
        countryCode: 'GQ',
        region: 'Africa'
    },
    {
        countryCode: 'GR',
        region: 'Europe1'
    },
    {
        countryCode: 'GS',
        region: 'South/Latin America'
    },
    {
        countryCode: 'GT',
        region: 'South/Latin America'
    },
    {
        countryCode: 'GU',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'GW',
        region: 'Africa'
    },
    {
        countryCode: 'GY',
        region: 'South/Latin America'
    },
    {
        countryCode: 'HK',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'HN',
        region: 'South/Latin America'
    },
    {
        countryCode: 'HR',
        region: 'Europe1',
        vatRate: 0.25
    },
    {
        countryCode: 'HT',
        region: 'South/Latin America'
    },
    {
        countryCode: 'HU',
        region: 'Europe1'
    },
    {
        countryCode: 'ID',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'IE',
        region: 'Europe1'
    },
    {
        countryCode: 'IL',
        region: 'Europe'
    },
    {
        countryCode: 'IM',
        region: 'Europe'
    },
    {
        countryCode: 'IN',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'IO',
        region: 'Indian Ocean'
    },
    {
        countryCode: 'IQ',
        region: 'Arab States'
    },
    {
        countryCode: 'IR',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'IS',
        region: 'Europe'
    },
    {
        countryCode: 'IT',
        region: 'Europe1',
        vatRate: 0.22
    },
    {
        countryCode: 'JE',
        region: 'Europe'
    },
    {
        countryCode: 'JM',
        region: 'South/Latin America'
    },
    {
        countryCode: 'JO',
        region: 'Arab States'
    },
    {
        countryCode: 'JP',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'KE',
        region: 'Africa2'
    },
    {
        countryCode: 'KG',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'KH',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'KP',
        region: 'Asia'
    },
    {
        countryCode: 'KR',
        region: 'Asia'
    },
    {
        countryCode: 'KI',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'KN',
        region: 'South/Latin America'
    },
    {
        countryCode: 'KW',
        region: 'Arab States'
    },
    {
        countryCode: 'KZ',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'LB',
        region: 'Arab States'
    },
    {
        countryCode: 'LC',
        region: 'South/Latin America'
    },
    {
        countryCode: 'LI',
        region: 'Europe'
    },
    {
        countryCode: 'LK',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'LR',
        region: 'Africa'
    },
    {
        countryCode: 'LS',
        region: 'Africa2'
    },
    {
        countryCode: 'LT',
        region: 'Europe1'
    },
    {
        countryCode: 'LU',
        region: 'Europe1'
    },
    {
        countryCode: 'LV',
        region: 'Europe1'
    },
    {
        countryCode: 'LY',
        region: 'Africa'
    },
    {
        countryCode: 'MA',
        region: 'Africa2'
    },
    {
        countryCode: 'MC',
        region: 'Europe'
    },
    {
        countryCode: 'ME',
        region: 'Europe'
    },
    {
        countryCode: 'MF',
        region: 'South/Latin America'
    },
    {
        countryCode: 'MG',
        region: 'Africa'
    },
    {
        countryCode: 'ML',
        region: 'Africa'
    },
    {
        countryCode: 'MM',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'MN',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'MO',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'MQ',
        region: 'South/Latin America'
    },
    {
        countryCode: 'MR',
        region: 'Africa'
    },
    {
        countryCode: 'MS',
        region: 'South/Latin America'
    },
    {
        countryCode: 'MT',
        region: 'Europe1'
    },
    {
        countryCode: 'MU',
        region: 'Africa'
    },
    {
        countryCode: 'MV',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'MW',
        region: 'Africa'
    },
    {
        countryCode: 'MX',
        region: 'South/Latin America'
    },
    {
        countryCode: 'MY',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'MZ',
        region: 'Africa2'
    },
    {
        countryCode: 'NA',
        region: 'Africa'
    },
    {
        countryCode: 'NC',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'NF',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'NG',
        region: 'Africa2'
    },
    {
        countryCode: 'NI',
        region: 'South/Latin America'
    },
    {
        countryCode: 'NO',
        region: 'Europe1',
        vatRate: 0.25
    },
    {
        countryCode: 'NP',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'NR',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'NU',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'NZ',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'OM',
        region: 'Arab States'
    },
    {
        countryCode: 'PA',
        region: 'South/Latin America'
    },
    {
        countryCode: 'PE',
        region: 'South/Latin America'
    },
    {
        countryCode: 'PF',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'PG',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'PK',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'PL',
        region: 'Europe1'
    },
    {
        countryCode: 'PM',
        region: 'North America'
    },
    {
        countryCode: 'PN',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'PR',
        region: 'South/Latin America'
    },
    {
        countryCode: 'PS',
        region: 'Arab States'
    },
    {
        countryCode: 'PT',
        region: 'Europe1'
    },
    {
        countryCode: 'PW',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'PY',
        region: 'South/Latin America'
    },
    {
        countryCode: 'QA',
        region: 'Arab States'
    },
    {
        countryCode: 'RE',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'RO',
        region: 'Europe1'
    },
    {
        countryCode: 'RS',
        region: 'Europe'
    },
    {
        countryCode: 'RU',
        region: 'Europe'
    },
    {
        countryCode: 'RW',
        region: 'Africa'
    },
    {
        countryCode: 'SA',
        region: 'Arab States'
    },
    {
        countryCode: 'SB',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'SC',
        region: 'Africa'
    },
    {
        countryCode: 'SE',
        region: 'Europe1',
        vatRate: 0.25
    },
    {
        countryCode: 'SG',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'SH',
        region: 'Africa'
    },
    {
        countryCode: 'SI',
        region: 'Europe1'
    },
    {
        countryCode: 'SJ',
        region: 'Europe'
    },
    {
        countryCode: 'SK',
        region: 'Europe1'
    },
    {
        countryCode: 'SL',
        region: 'Africa'
    },
    {
        countryCode: 'SM',
        region: 'Europe'
    },
    {
        countryCode: 'SN',
        region: 'Africa'
    },
    {
        countryCode: 'SO',
        region: 'Africa'
    },
    {
        countryCode: 'SR',
        region: 'South/Latin America'
    },
    {
        countryCode: 'SS',
        region: 'Africa'
    },
    {
        countryCode: 'ST',
        region: 'Africa'
    },
    {
        countryCode: 'SV',
        region: 'South/Latin America'
    },
    {
        countryCode: 'SX',
        region: 'Unknown'
    },
    {
        countryCode: 'SY',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'TD',
        region: 'Africa'
    },
    {
        countryCode: 'TG',
        region: 'Africa'
    },
    {
        countryCode: 'TH',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'TJ',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'TK',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'TL',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'TM',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'TN',
        region: 'Africa'
    },
    {
        countryCode: 'TO',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'TR',
        region: 'Europe'
    },
    {
        countryCode: 'TT',
        region: 'South/Latin America'
    },
    {
        countryCode: 'TV',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'TZ',
        region: 'Africa'
    },
    {
        countryCode: 'UA',
        region: 'Europe'
    },
    {
        countryCode: 'UG',
        region: 'Africa'
    },
    {
        countryCode: 'US',
        region: 'North America'
    },
    {
        countryCode: 'UY',
        region: 'South/Latin America'
    },
    {
        countryCode: 'UZ',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'VC',
        region: 'South/Latin America'
    },
    {
        countryCode: 'VE',
        region: 'South/Latin America'
    },
    {
        countryCode: 'VG',
        region: 'South/Latin America'
    },
    {
        countryCode: 'VI',
        region: 'South/Latin America'
    },
    {
        countryCode: 'VN',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'VU',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'WF',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'WS',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'YE',
        region: 'Arab States'
    },
    {
        countryCode: 'YT',
        region: 'Africa'
    },
    {
        countryCode: 'ZA',
        region: 'Africa2'
    },
    {
        countryCode: 'ZM',
        region: 'Africa'
    },
    {
        countryCode: 'ZW',
        region: 'Africa'
    },
    {
        countryCode: 'SZ',
        region: 'Africa'
    },
    {
        countryCode: 'MK',
        region: 'Europe'
    },
    {
        countryCode: 'PH',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'NL',
        region: 'Europe1'
    },
    {
        countryCode: 'AE',
        region: 'Arab States'
    },
    {
        countryCode: 'MD',
        region: 'Europe'
    },
    {
        countryCode: 'GM',
        region: 'Africa'
    },
    {
        countryCode: 'DO',
        region: 'South/Latin America'
    },
    {
        countryCode: 'SD',
        region: 'Africa'
    },
    {
        countryCode: 'LA',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'TW',
        region: 'Asia & Pacific'
    },
    {
        countryCode: 'CG',
        region: 'Africa'
    },
    {
        countryCode: 'CZ',
        region: 'Europe1'
    },
    {
        countryCode: 'GB',
        region: 'Europe1',
        vatRate: 0.2
    },
    {
        countryCode: 'NE',
        region: 'Africa'
    },
    {
        countryCode: 'CD',
        region: 'Africa'
    },
    {
        countryCode: 'BS',
        region: 'Caribbean'
    },
    {
        countryCode: 'CC',
        region: 'Australia'
    },
    {
        countryCode: 'CF',
        region: 'Africa'
    },
    {
        countryCode: 'CK',
        region: 'South Pacific Ocean'
    },
    {
        countryCode: 'FK',
        region: 'South Atlantic Ocean'
    },
    {
        countryCode: 'FO',
        region: 'Europe'
    },
    {
        countryCode: 'HM',
        region: 'Indian Ocean'
    },

    {
        countryCode: 'KM',
        region: 'Indian Ocean'
    },
    {
        countryCode: 'KY',
        region: 'Caribbean Sea'
    },
    {
        countryCode: 'MH',
        region: 'Pacific Ocean'
    },
    {
        countryCode: 'MP',
        region: 'Pacific Ocean'
    },
    {
        countryCode: 'TC',
        region: 'Atlantic Ocean'
    },
    {
        countryCode: 'TF',
        region: 'Indian Ocean'
    },
    {
        countryCode: 'UM',
        region: 'Pacific Ocean'
    },
    {
        countryCode: 'VA',
        region: 'Europe'
    },
    {
        countryCode: 'XK',
        region: 'Europe'
    },
    {
        countryCode: 'AN',
        region: 'Europe'
    }
];

export default countriesRegions;
